import { render, staticRenderFns } from "./MachineRepairStatistics.vue?vue&type=template&id=5423b6d9&"
import script from "./MachineRepairStatistics.vue?vue&type=script&lang=js&"
export * from "./MachineRepairStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MachineRepairStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports